let mod = null;
let loading = null;
export const preloadPhone = () => loading || (loading = import("./phone").then((m) => { mod = m; }));

// Exact check once the phone library is loaded; until then a basic format check (the server validates again).
export function validPhone(v) {
  if (mod) return mod.validPhone(v);
  preloadPhone();
  return /^\+?\d{8,15}$/.test((v || "").replace(/[\s\-().]/g, ""));
}
